"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cookie = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cookie = exports.Cookie = /*#__PURE__*/function () {
  function Cookie() {
    _classCallCheck(this, Cookie);
  }
  return _createClass(Cookie, null, [{
    key: "getCookieUrl",
    value: function getCookieUrl(cookieName, defaultUrl) {
      var cookieUrl = Cookie.readCookie(cookieName);
      if (cookieUrl !== null) {
        return cookieUrl;
      }
      return defaultUrl;
    }
  }, {
    key: "readCookie",
    value: function readCookie(name) {
      try {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        var _iterator = _createForOfIteratorHelper(ca),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var c = _step.value;
            while (c.startsWith(' ')) {
              c = c.substring(1, c.length);
            }
            if (c.startsWith(nameEQ)) {
              return c.substring(nameEQ.length, c.length);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } catch (e) {
        // Helpers.sendWrapperLoadError uses this method to get some context
        // for the reported error, so we don't want to call that here, otherwise
        // we would get stuck in an infinite loop

        // Missing login_user_detected cookie is expected for logged out users, so no need to log it.
        if (name !== 'login_user_detected') {
          console.warn("Error reading cookie - ".concat(name), e);
        }
      }
      return null;
    }
  }, {
    key: "writeCookie",
    value: function writeCookie(name, value, days, topLevelDomain) {
      var seconds = days ? days * 24 * 60 * 60 : null;
      Cookie.writeCookieInSeconds(name, value, seconds, topLevelDomain);
    }
  }, {
    key: "writeCookieInSeconds",
    value: function writeCookieInSeconds(name, value, seconds, topLevelDomain) {
      try {
        var expires = '';
        if (seconds) {
          var date = new Date();
          date.setTime(date.getTime() + seconds * 1000);
          expires = '; expires=' + date.toUTCString();
        }
        var cookie = name + '=' + value + expires + '; path=/;';
        var domain = window.location.hostname;
        if (domain !== 'localhost' && topLevelDomain) {
          var domainTokens = domain.split('.');
          if (domainTokens.length > 1) {
            var lastToken = domainTokens[domainTokens.length - 1];
            var secondLastToken = domainTokens[domainTokens.length - 2];
            if (isNaN(Number(lastToken)) || isNaN(Number(secondLastToken))) {
              domain = '.' + secondLastToken + '.' + lastToken;
            }
          }
          cookie += ' domain=' + domain + ';';
        }
        document.cookie = cookie;
      } catch (e) {
        console.warn("Error writing cookie - ".concat(name), e);
      }
    }
  }]);
}();